module.exports = __webpack_public_path__ + "img/AddIcCallOutlined.777ff084.svg";